module.exports = __webpack_public_path__ + "img/shrimp.37fcb147.png";